var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#1f1f1f",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m628.85-281.69 46.77-46.77q5.61-5.58 5.61-13.02 0-7.44-5.61-13.06L531.54-499.23q5.15-11.38 7.73-23.73t2.58-27.5q0-54.94-39.15-93.97t-94.24-39.03q-15.84 0-30.88 3.89t-29.19 10.8l88.61 89-59.08 59.08-89.38-89q-6.85 14.08-10.77 29.34-3.92 15.27-3.92 31.12 0 55.09 39.14 94.24 39.15 39.14 94.24 39.14 14.11 0 26.59-2.77 12.49-2.77 24.64-7.53l144.69 144.07q5.62 5.62 12.85 5.81 7.23.19 12.85-5.42ZM480.07-100q-78.84 0-148.21-29.92t-120.68-81.21q-51.31-51.29-81.25-120.63Q100-401.1 100-479.93q0-78.84 29.92-148.21t81.21-120.68q51.29-51.31 120.63-81.25Q401.1-860 479.93-860q78.84 0 148.21 29.92t120.68 81.21q51.31 51.29 81.25 120.63Q860-558.9 860-480.07q0 78.84-29.92 148.21t-81.21 120.68q-51.29 51.31-120.63 81.25Q558.9-100 480.07-100Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestIcon);
export default __webpack_public_path__ + "static/media/test_icon.10d03efd21d26db7aef33e6a4cdc216f.svg";
export { ForwardRef as ReactComponent };